import { Container } from "@mui/material";
import { Box } from "@mui/system";
import { useMemo } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

import { ROUTES } from "../../commons";

// import Unauthorized from "./Unauthorized";

const _ = ({ element, isInitializing, isAuthenticated }) => {
  const _element = useMemo(() => {
    if (isAuthenticated) {
      return element;
    } else {
      const searchParams = new URLSearchParams();
      searchParams.append(
        "next",
        document.location.href.substring(document.location.origin.length)
      );
      return (
        <Navigate to={`/auth${ROUTES.Signin}?${searchParams.toString()}`} />
      );
    }
  }, [isAuthenticated, element]);

  return !isInitializing ? (
    _element
  ) : (
    <Container style={{ height: "100%" }}>
      <Box
        display="flex"
        height="100%"
        justifyContent="center"
        alignItems="center"
      >
        We are checking the certification...
      </Box>
    </Container>
  );
};

const mapState = ({ auth: { isInitializing, isAuthenticated } }) => ({
  isInitializing,
  isAuthenticated,
});
export default connect(mapState)(_);
